// import axios from '@/utils/axios';
import { fetchWrapper } from '@/utils/helpers/fetch-wrapper';
// import { useRoute  } from 'vue-router';
import { toast } from '@/utils/toast';
import Form from 'vform';
import { useAuthStore } from '@/stores/auth';
import Roles from '@/utils/roles';
import { isFullAdmin } from '@/utils/fullAdmin';
import moment from 'moment';
import loadash from 'lodash';
import { fallbackMessage } from '@/utils/errorEnvelope';
import jQuery from 'jquery';
import { ref } from 'vue';
import { useDate } from 'vuetify';
import { store, key } from '@/storeVuex';
import { useGtag } from 'vue-gtag-next';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export function GlobalVariables(app, router) {
    app.config.globalProperties.$baseUrl = `${import.meta.env.VITE_API_URL}`;
    app.config.globalProperties.$baseUrlApi = `${import.meta.env.VITE_API_URL_API}`;
    app.config.globalProperties.$toast = toast;
    app.config.globalProperties.$_ = loadash;
    app.config.globalProperties.$ref = ref;
    app.config.globalProperties.$useDate = useDate;
    // app.config.globalProperties.$useRoute = useRoute;
    app.config.globalProperties.$useAuthStore = useAuthStore;
    app.config.globalProperties.$Form = Form;
    app.config.globalProperties.$axios = fetchWrapper;
    app.config.globalProperties.$router = router;
    app.config.globalProperties.$role = new Roles(store, router);
    // Templates ask "is this user a full admin?" in many places; give them one
    // implementation instead of an inline usertype_lbl string comparison.
    app.config.globalProperties.$isFullAdmin = isFullAdmin;
    app.config.globalProperties.$moment = moment;
    app.config.globalProperties.$jQuery = jQuery;
    // app.config.globalProperties.$ClassicEditor = ClassicEditor;

    // Google Analytics - using useGtag() composable
    const gtag = useGtag();
    app.config.globalProperties.$gtag = gtag;

    // FILTERS
    app.config.globalProperties.$filters = {
        setDate(val: Date) {
            if (!val) return null;
            return moment(val).format('MMM. DD, YYYY');
        },
        timeFilter(val: Date) {
            if (!val) return null;
            return moment(val, ['h:mm A']).format('h:mm a');
        },
        datetime(val: Date) {
            if (!val) return null;
            return moment(val).format('MMM. DD, YYYY h:mm a');
        },
        toNumberWithDecimal(val: number) {
            if (typeof val !== 'number') {
                return '0';
            }
            const formatter = new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 0 });
            return formatter.format(val);
        },
        toNumberDelimited(val: number) {
            if (typeof val !== 'number') {
                return '0';
            }
            const formatter = new Intl.NumberFormat('zh-CN');
            return formatter.format(val);
        },
        toCurrency(val: number) {
            if (typeof val !== 'number') {
                return val;
            }
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });
            return formatter.format(val);
        },
        getAge(birthdate: Date) {
            // Ensure the input is a valid date string
            const birthDateObject = new Date(birthdate);

            // Check if the birthdate is a valid date
            if (isNaN(birthDateObject.getTime())) {
                throw new Error('Invalid date format. Please provide a valid date.');
            }

            // Get the current date
            const currentDate = new Date();

            // Calculate the difference in years
            const age = currentDate.getFullYear() - birthDateObject.getFullYear();

            // Adjust the age if the birthday hasn't occurred yet this year
            if (
                currentDate.getMonth() < birthDateObject.getMonth() ||
                (currentDate.getMonth() === birthDateObject.getMonth() && currentDate.getDate() < birthDateObject.getDate())
            ) {
                return age - 1;
            }

            return age;
        },
        statusColor(val: string) {
            val = val.toLowerCase();
            switch (val) {
                case 'unscheduled':
                case 'pending':
                    return 'info';
                    break;
                case 'unpaid':
                case 'scheduled':
                    return 'warning';
                    break;
                case 'released':
                    return 'primary';
                    break;
                case 'approved':
                case 'completed':
                case 'paid':
                case 'active':
                    return 'success';
                    break;
                case 'declined':
                case 'cancelled':
                case 'inactive':
                    return 'error';
                    break;
            }
        },
        uploadImage(object: any) {
            let arr: any;

            object.form.images.forEach((element: any) => {
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = (e: any) => {
                    arr.push(e.target.result);
                };
            });
            object.form.imageupload = arr;
        },
        responseMessage(val) {
            const response = loadash.filter(val, 'response_message');
            let message = response.length > 0 ? response[0].response_message : '';
            let isError = true;
            if (val && val.status) {
                if (val.status == 200) {
                    isError = false;
                }
            }

            // Anything the lodash scan could not read used to end here showing
            // nothing at all. Recover the message from the other envelope shapes
            // the API and the call sites actually send. bsapi#107.
            if (!message) {
                const fallback = fallbackMessage(val);
                if (!fallback) return;
                message = fallback.message;
                isError = fallback.isError;
            }

            try {
                if (isError) {
                    toast.error(message);
                } else {
                    toast.success(message);
                }
            } catch (error) {
                console.error('Toast notification failed to display:', error);

                // Track toast display failure in Sentry
                if (window.Sentry) {
                    window.Sentry.captureException(error, {
                        tags: {
                            error_type: 'toast_display_failed',
                            toast_type: isError ? 'error' : 'success',
                            component: 'GlobalVariables'
                        },
                        contexts: {
                            toast_context: {
                                message: message,
                                is_error: isError,
                                status: val?.status || 'none',
                                response_data: JSON.stringify(val).substring(0, 1000)
                            }
                        }
                    });
                }
            }
        },
        responseForm(val) {
            // Must always return an object: callers do `this.formerror = $filters.responseForm(err)`
            // and templates index `formerror[field]`. Returning undefined caused TypeError on re-render.
            if (val && val.alert_message) {
                return val.alert_message;
            }
            return {};
        }
    };

    app.mixin({
        data: function () {
            return {
                dialog: false,
                isSearchLoading: false,
                tbl_search: null,
                tbl_package_id: null,
                tbl_trans_type_id: null,
                tbl_dateFrom: null,
                tbl_dateTo: null,
                tbl_type: null,
                tbl_status: null,
                // tbl_dateFrom: this.$moment(new Date()).startOf('month').format("YYYY-MM-DD"),
                // tbl_dateTo: this.$moment(new Date()).endOf('month').format("YYYY-MM-DD"),
                formerror: {},
                indexData: [],
                editmode: false,
                isSubmitting: false,
                pagination: {
                    current: 1,
                    total: 0,
                    last_page: 0,
                    perpage: 50,
                    totalBalance: 0,
                    totalAmount: 0
                }
            };
        }
    });
}
